import { ActivityLogParser } from '@/parsers/activityLog'

export class PostingTypeActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'name': 'localized',
    }
}
